// @ts-nocheck
import React, { useEffect, useState, useCallback } from "react";
import { Users, Plus, Pencil, Trash2 } from "lucide-react";
import UsermanMenu from "../components/UsermanMenu.js";
import { useSearchParams } from "react-router-dom";

const apiBaseUrl = "https://api.wifikamu.my.id";

const initialFormState = {
  name: "",
  download_limit: "",
  upload_limit: "",
  transfer_limit: "",
  uptime_limit: "",
  reset_counters_start_time: "",
  reset_counters_interval: "",
  rate_limit_rx: "",
  rate_limit_tx: "",
  rate_limit_burst_rx: "",
  rate_limit_burst_tx: "",
  rate_limit_burst_threshold_rx: "",
  rate_limit_burst_threshold_tx: "",
  rate_limit_burst_time_rx: "",
  rate_limit_burst_time_tx: "",
  rate_limit_min_rx: "",
  rate_limit_min_tx: "",
  rate_limit_priority: "",
};

const UsermanLimitation = () => {
  const [searchParams] = useSearchParams();
  const usermanId = searchParams.get("userman_id");
  const deviceName = searchParams.get("device_name");

  const [data, setData] = useState([]);
  const [form, setForm] = useState(initialFormState);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [currentLimitation, setCurrentLimitation] = useState(null);
  const [message, setMessage] = useState({ type: "", text: "" });

  // GET data
  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(
        `${apiBaseUrl}/userman-limitation-get/${usermanId}`
      );
      const result = await res.json();
      if (result.success) {
        setData(result.data || []);
      } else {
        setMessage({ type: "error", text: result.message });
      }
    } catch (err) {
      console.error(err);
      setMessage({ type: "error", text: "Failed to fetch data" });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // Handle input
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // POST add
  const handleAdd = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${apiBaseUrl}/userman-limitation-add`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userman_id: usermanId, newLimitation: form }),
      });
      const result = await res.json();
      if (result.success) {
        setMessage({ type: "success", text: result.message });
        setForm(initialFormState);
        setIsOpen(false);
        fetchData();
      } else {
        setMessage({ type: "error", text: result.message });
      }
    } catch (err) {
      console.error(err);
      setMessage({ type: "error", text: "Failed to add limitation" });
    } finally {
      setLoading(false);
    }
  };

  // PUT update
  const handleUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${apiBaseUrl}/userman-limitation-update`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userman_id: usermanId,
          updatedLimitation: form,
        }),
      });
      const result = await res.json();
      if (result.success) {
        setMessage({ type: "success", text: result.message });
        setEditOpen(false);
        fetchData();
      } else {
        setMessage({ type: "error", text: result.message });
      }
    } catch (err) {
      console.error(err);
      setMessage({ type: "error", text: "Failed to update limitation" });
    } finally {
      setLoading(false);
    }
  };

  // DELETE
  const handleDelete = async (name) => {
    if (!window.confirm(`Yakin hapus limitation ${name}?`)) return;
    setLoading(true);
    try {
      const res = await fetch(
        `${apiBaseUrl}/userman-profile-limitation-delete`,
        {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            userman_id: usermanId,
            limitation_name: name,
          }),
        }
      );
      const result = await res.json();
      if (result.success) {
        setMessage({ type: "success", text: result.message });
        fetchData();
      } else {
        setMessage({ type: "error", text: result.message });
      }
    } catch (err) {
      console.error(err);
      setMessage({ type: "error", text: "Failed to delete limitation" });
    } finally {
      setLoading(false);
    }
  };

  const openEditModal = (item) => {
    setCurrentLimitation(item);
    setForm({
      name: item.name || "",
      download_limit: item["download-limit"] || "",
      upload_limit: item["upload-limit"] || "",
      transfer_limit: item["transfer-limit"] || "",
      uptime_limit: item["uptime-limit"] || "",
      reset_counters_start_time: item["reset-counters-start-time"] || "",
      reset_counters_interval: item["reset-counters-interval"] || "",
      rate_limit_rx: item["rate-limit-rx"] || "",
      rate_limit_tx: item["rate-limit-tx"] || "",
      rate_limit_burst_rx: item["rate-limit-burst-rx"] || "",
      rate_limit_burst_tx: item["rate-limit-burst-tx"] || "",
      rate_limit_burst_threshold_rx:
        item["rate-limit-burst-threshold-rx"] || "",
      rate_limit_burst_threshold_tx:
        item["rate-limit-burst-threshold-tx"] || "",
      rate_limit_burst_time_rx: item["rate-limit-burst-time-rx"] || "",
      rate_limit_burst_time_tx: item["rate-limit-burst-time-tx"] || "",
      rate_limit_min_rx: item["rate-limit-min-rx"] || "",
      rate_limit_min_tx: item["rate-limit-min-tx"] || "",
      rate_limit_priority: item["rate-limit-priority"] || "",
    });
    setEditOpen(true);
  };

  const renderForm = (onSubmit) => (
    <form onSubmit={onSubmit} className="space-y-3">
      {/* grid wrapper */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {Object.keys(initialFormState).map((key) => (
          <div key={key}>
            <label className="block text-sm font-medium mb-1">{key}</label>
            <input
              type="text"
              name={key}
              value={form[key]}
              onChange={handleChange}
              className="w-full border rounded px-3 py-2 text-sm dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            />
          </div>
        ))}
      </div>

      {/* action button */}
      <div className="flex gap-2 justify-end pt-3">
        <button
          type="submit"
          className="px-4 py-2 bg-blue-600 text-white rounded"
        >
          Save
        </button>
      </div>
    </form>
  );

  return (
    <div className="p-6">
      <h1 className="flex items-center gap-2 text-xl font-bold mb-4">
        <Users size={20} /> {deviceName} /
        <UsermanMenu userman_id={usermanId} device_name={deviceName} />/
        Limitation
      </h1>

      {message.text && (
        <div
          className={`mb-4 p-3 rounded ${
            message.type === "success" ? "bg-green-200" : "bg-red-200"
          }`}
        >
          {message.text}
        </div>
      )}

      <button
        onClick={() => setIsOpen(true)}
        className="mb-4 flex items-center gap-1 bg-green-600 text-white px-3 py-2 rounded"
      >
        <Plus size={16} /> Add Limitation
      </button>

      <div className="overflow-x-auto rounded shadow bg-white dark:bg-gray-800">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-100 dark:bg-gray-700">
            <tr>
              <th className="p-2 text-left">Name</th>
              <th className="p-2 text-left">Download</th>
              <th className="p-2 text-left">Upload</th>
              <th className="p-2 text-left">Transfer</th>
              <th className="p-2 text-left">Uptime</th>
              <th className="p-2 text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="6" className="p-4 text-center">
                  Loading...
                </td>
              </tr>
            ) : data.length > 0 ? (
              data.map((item) => (
                <tr key={item[".id"]} className="border-t dark:border-gray-700">
                  <td className="p-2">{item.name}</td>
                  <td className="p-2">{item["download-limit"] || "-"}</td>
                  <td className="p-2">{item["upload-limit"] || "-"}</td>
                  <td className="p-2">{item["transfer-limit"] || "-"}</td>
                  <td className="p-2">{item["uptime-limit"] || "-"}</td>
                  <td className="p-2 flex justify-center gap-3">
                    <button
                      onClick={() => openEditModal(item)}
                      className="px-3 py-2 text-blue-600 hover:text-blue-800 border border-blue-600 hover:border-blue-800 rounded-md text-xs"
                    >
                      <Pencil size={14} /> Edit
                    </button>
                    <button
                      onClick={() => handleDelete(item.name)}
                      className="px-3 py-2 text-red-600 hover:text-red-800 border border-red-600 hover:border-red-800 rounded-md text-xs"
                    >
                      <Trash2 size={14} /> Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="p-4 text-center text-gray-500">
                  No limitations found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Add Modal */}
      {isOpen && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center">
          <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg max-w-md w-full">
            <h2 className="text-lg font-semibold mb-4">Add Limitation</h2>
            {renderForm(handleAdd)}
            <button
              onClick={() => setIsOpen(false)}
              className="px-4 py-2 bg-gray-500 text-white rounded"
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      {editOpen && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center">
          <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg max-w-md w-full">
            <h2 className="text-lg font-semibold mb-4">
              Edit Limitation: {currentLimitation?.name}
            </h2>
            {renderForm(handleUpdate)}
            <button
              onClick={() => setEditOpen(false)}
              className="px-4 py-2 bg-gray-500 text-white rounded"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UsermanLimitation;
